/* eslint-disable max-lines */
import { ArgentinaFlag } from './Argentina';
import { ArmeniaFlag } from './Armenia';
import { AustraliaFlag } from './Australia';
import { AustriaFlag } from './Austria';
import { AzerbaijanFlag } from './Azerbaijan';
import { BahamasFlag } from './Bahamas';
import { BahrainFlag } from './Bahrain';
import { BangladeshFlag } from './Bangladesh';
import { BarbadosFlag } from './Barbados';
import { BelarusFlag } from './Belarus';
import { BelgiumFlag } from './Belgium';
import { BelizeFlag } from './Belize';
import { BeninFlag } from './Benin';
import { BermudaFlag } from './Bermuda';
import { BhutanFlag } from './Bhutan';
import { BoliviaFlag } from './Bolivia';
import { BonaireFlag } from './Bonaire';
import { BosniaFlag } from './Bosnia';
import { BotswanaFlag } from './Botswana';
import { BouvetIslandFlag } from './BouvetIsland';
import { BrazilFlag } from './Brazil';
import { BritishIndianOceanTerritoryFlag } from './BritishIndianOceanTerritory';
import { BruneiDarussalamFlag } from './BruneiDarussalam';
import { BulgariaFlag } from './Bulgaria';
import { BurkinaFlag } from './Burkina';
import { BurundiFlag } from './Burundi';
import { CaboVerdeFlag } from './CaboVerde';
import { CambodiaFlag } from './Cambodia';
import { CameroonFlag } from './Cameroon';
import { CanadaFlag } from './Canada';
import { CaymanIslandsFlag } from './CaymanIslands';
import { CentralAfricanRepublicFlag } from './CentralAfricanRepublic';
import { ChadFlag } from './Chad';
import { ChileFlag } from './Chile';
import { ChinaFlag } from './China';
import { ChristmasIslandFlag } from './ChristmasIsland';
import { CocosIslandsFlag } from './CocosIslands';
import { ColombiaFlag } from './Colombia';
import { ComorsFlag } from './Comors';
import { CookIslandsFlag } from './CookIslands';
import { CostaRicaFlag } from './CostaRica';
import { CroatiaFlag } from './Croatia';
import { CubaFlag } from './Cuba';
import { CuracaoFlag } from './Curacao';
import { CyprusFlag } from './Cyprus';
import { CzechRepublicFlag } from './CzechRepublic';
import { DemocraticRepublicOfTheCongoFlag } from './DemocraticRepublicOfTheCongo';
import { DenmarkFlag } from './Denmark';
import { DjiboutiFlag } from './Djibouti';
import { DominicaFlag } from './Dominica';
import { DominicanRepublicFlag } from './DominicanRepublic';
import { EcuadorFlag } from './Ecuador';
import { EgyptFlag } from './Egypt';
import { ElSalvadorFlag } from './ElSalvador';
import { EnglandFlag } from './England';
import { EquatorialGuineaFlag } from './EquatorialGuinea';
import { EritreaFlag } from './Eritrea';
import { EstoniaFlag } from './Estonia';
import { EthiopiaFlag } from './Ethiopia';
import { EuropeanUnionFlag } from './EuropeanUnion';
import { FalklandIslandsFlag } from './FalklandIslands';
import { FaroeIslandsFlag } from './FaroeIslands';
import { FederatedStatesOfMicronesiaFlag } from './FederatedStatesOfMicronesia';
import { FijiFlag } from './Fiji';
import { FinlandFlag } from './Finland';
import { FranceFlag } from './France';
import { FrenchGuianaFlag } from './FrenchGuiana';
import { FrenchPolynesiaFlag } from './FrenchPolynesia';
import { FrenchSouthernAndAntarcticLandsFlag } from './FrenchSouthernAndAntarcticLands';
import { GabonFlag } from './Gabon';
import { GambiaFlag } from './Gambia';
import { GeorgiaFlag } from './Georgia';
import { GermanyFlag } from './Germany';
import { GhanaFlag } from './Ghana';
import { GibraltarFlag } from './Gibraltar';
import { GreeceFlag } from './Greece';
import { GrenadaFlag } from './Grenada';
import { GuadeloupeFlag } from './Guadeloupe';
import { GuamFlag } from './Guam';
import { GuatemalaFlag } from './Guatemala';
import { GuernseyFlag } from './Guernsey';
import { GuineaFlag } from './Guinea';
import { GuineaBissauFlag } from './GuineaBissau';
import { GuyanaFlag } from './Guyana';
import { HaitiFlag } from './Haiti';
import { HeardAndMcDonaldIslandsFlag } from './HeardAndMcDonaldIslands';
import { HondurasFlag } from './Honduras';
import { HongKongFlag } from './HongKong';
import { HungaryFlag } from './Hungary';
import { IcelandFlag } from './Iceland';
import { IndiaFlag } from './India';
import { IndonesiaFlag } from './Indonesia';
import { IranFlag } from './Iran';
import { IraqFlag } from './Iraq';
import { IrelandFlag } from './Ireland';
import { IsleOfManFlag } from './IsleOfMan';
import { IsraelFlag } from './Israel';
import { ItalyFlag } from './Italy';
import { IvoryCoastFlag } from './IvoryCoast';
import { JamaicaFlag } from './Jamaica';
import { JapanFlag } from './Japan';
import { JerseyFlag } from './Jersey';
import { JordanFlag } from './Jordan';
import { KazakhstanFlag } from './Kazakhstan';
import { KeniaFlag } from './Kenia';
import { KiribatiFlag } from './Kiribati';
import { KuwaitFlag } from './Kuwait';
import { KyrgyzstanFlag } from './Kyrgyzstan';
import { LaosFlag } from './Laos';
import { LatviaFlag } from './Latvia';
import { LebanonFlag } from './Lebanon';
import { LesothoFlag } from './Lesotho';
import { LiberiaFlag } from './Liberia';
import { LibyaFlag } from './Libya';
import { LiechtensteinFlag } from './Liechtenstein';
import { LithuaniaFlag } from './Lithuania';
import { LuxembourgFlag } from './Luxembourg';
import { MacaoFlag } from './Macao';
import { MadagascarFlag } from './Madagascar';
import { MalawiFlag } from './Malawi';
import { MalaysiaFlag } from './Malaysia';
import { MaldivesFlag } from './Maldives';
import { MaliFlag } from './Mali';
import { MaltaFlag } from './Malta';
import { MarshallIslandsFlag } from './MarshallIslands';
import { MartiniqueFlag } from './Martinique';
import { MauritaniaFlag } from './Mauritania';
import { MauritiusFlag } from './Mauritius';
import { MayotteFlag } from './Mayotte';
import { MexicoFlag } from './Mexico';
import { MoldovaFlag } from './Moldova';
import { MonacoFlag } from './Monaco';
import { MongoliaFlag } from './Mongolia';
import { MontenegroFlag } from './Montenegro';
import { MontserratFlag } from './Montserrat';
import { MoroccoFlag } from './Morocco';
import { MozambiqueFlag } from './Mozambique';
import { MyanmarFlag } from './Myanmar';
import { NamibiaFlag } from './Namibia';
import { NauruFlag } from './Nauru';
import { NepalFlag } from './Nepal';
import { NetherlandsFlag } from './Netherlands';
import { NewCaledoniaFlag } from './NewCaledonia';
import { NewZealandFlag } from './NewZealand';
import { NicaraguaFlag } from './Nicaragua';
import { NigerFlag } from './Niger';
import { NigeriaFlag } from './Nigeria';
import { NiueFlag } from './Niue';
import { NorfolkIslandFlag } from './NorfolkIsland';
import { NorthernIrelandFlag } from './NorthernIreland';
import { NorthernMarianaIslandsFlag } from './NorthernMarianaIslands';
import { NorthKoreaFlag } from './NorthKorea';
import { NorthMacedoniaFlag } from './NorthMacedonia';
import { NorwayFlag } from './Norway';
import { OmanFlag } from './Oman';
import { PakistanFlag } from './Pakistan';
import { PalauFlag } from './Palau';
import { PanamaFlag } from './Panama';
import { PapuaNewGuineaFlag } from './PapuaNewGuinea';
import { ParaguayFlag } from './Paraguay';
import { PeruFlag } from './Peru';
import { PhilippinesFlag } from './Philippines';
import { PitcairnIslandsFlag } from './PitcairnIslands';
import { PolandFlag } from './Poland';
import { PortugalFlag } from './Portugal';
import { PuertoRicoFlag } from './PuertoRico';
import { QatarFlag } from './Qatar';
import { RepublicOfTheCongoFlag } from './RepublicOfTheCongo';
import { ReunionFlag } from './Reunion';
import { RomaniaFlag } from './Romania';
import { RussiaFlag } from './Russia';
import { RussianFederationFlag } from './RussianFederation';
import { RwandaFlag } from './Rwanda';
import { SabaFlag } from './Saba';
import { SaintBarthélemyFlag } from './SaintBarthélemy';
import { SaintHelenaFlag } from './SaintHelena';
import { SaintKittsAndNevisFlag } from './SaintKittsAndNevis';
import { SaintLuciaFlag } from './SaintLucia';
import { SaintMartinFlag } from './SaintMartin';
import { SaintPierreAndMiquelonFlag } from './SaintPierreAndMiquelon';
import { SaintVincentAndTheGrenadinesFlag } from './SaintVincentAndTheGrenadines';
import { SamoaFlag } from './Samoa';
import { SanMarinoFlag } from './SanMarino';
import { SaoTomeAndPrincipeFlag } from './SaoTomeAndPrincipe';
import { SaudiArabiaFlag } from './SaudiArabia';
import { ScotlandFlag } from './Scotland';
import { SenegalFlag } from './Senegal';
import { SerbiaFlag } from './Serbia';
import { SeychellesFlag } from './Seychelles';
import { SGSSIFlag } from './SGSSI';
import { SierraLeoneFlag } from './SierraLeone';
import { SingaporeFlag } from './Singapore';
import { SintEustatiusFlag } from './SintEustatius';
import { SintMaartenFlag } from './SintMaarten';
import { SlovakiaFlag } from './Slovakia';
import { SloveniaFlag } from './Slovenia';
import { SolomonIslandsFlag } from './SolomonIslands';
import { SomaliaFlag } from './Somalia';
import { SouthAfricaFlag } from './SouthAfrica';
import { SouthKoreaFlag } from './SouthKorea';
import { SouthSudanFlag } from './SouthSudan';
import { SpainFlag } from './Spain';
import { SriLankaFlag } from './SriLanka';
import { SudanFlag } from './Sudan';
import { SurinameFlag } from './Suriname';
import { SwazilandFlag } from './Swaziland';
import { SwedenFlag } from './Sweden';
import { SwitzerlandFlag } from './Switzerland';
import { SyriaFlag } from './Syria';
import { TaiwanFlag } from './Taiwan';
import { TajikistanFlag } from './Tajikistan';
import { TanzaniaFlag } from './Tanzania';
import { ThailandFlag } from './Thailand';
import { TimorLesteFlag } from './TimorLeste';
import { TogoFlag } from './Togo';
import { TokelauFlag } from './Tokelau';
import { TongaFlag } from './Tonga';
import { TrinidadAndTobagoFlag } from './TrinidadAndTobago';
import { TunisiaFlag } from './Tunisia';
import { TurkeyFlag } from './Turkey';
import { TurkmenistanFlag } from './Turkmenistan';
import { TurksAndCaicosIslandsFlag } from './TurksAndCaicosIslands';
import { TuvaluFlag } from './Tuvalu';
import { UAEFlag } from './UAE';
import { UgandaFlag } from './Uganda';
import { UKFlag } from './UK';
import { UkraineFlag } from './Ukraine';
import { UruguayFlag } from './Uruguay';
import { USAFlag } from './USA';
import { UzbekistanFlag } from './Uzbekistan';
import { VanuatuFlag } from './Vanuatu';
import { VaticanCityStateFlag } from './VaticanCityState';
import { VenezuelaFlag } from './Venezuela';
import { VietnamFlag } from './Vietnam';
import { VirginIslandsBritishFlag } from './VirginIslandsBritish';
import { VirginIslandsUSFlag } from './VirginIslandsUS';
import { WalesFlag } from './Wales';
import { WallisAndFutunaFlag } from './WallisAndFutuna';
import { WesternSaharaFlag } from './WesternSahara';
import { YemenFlag } from './Yemen';
import { ZambiaFlag } from './Zambia';
import { ZimbabweFlag } from './Zimbabwe';
export var flagsMap = {
  australia: AustraliaFlag,
  austria: AustriaFlag,
  armenia: ArmeniaFlag,
  argentina: ArgentinaFlag,
  azerbaijan: AzerbaijanFlag,
  bahamas: BahamasFlag,
  bahrain: BahrainFlag,
  bangladesh: BangladeshFlag,
  barbados: BarbadosFlag,
  belarus: BelarusFlag,
  belgium: BelgiumFlag,
  belize: BelizeFlag,
  benin: BeninFlag,
  bermuda: BermudaFlag,
  bhutan: BhutanFlag,
  bolivia: BoliviaFlag,
  bonaire: BonaireFlag,
  bosnia: BosniaFlag,
  botswana: BotswanaFlag,
  'bouvet-island': BouvetIslandFlag,
  bulgaria: BulgariaFlag,
  burkina: BurkinaFlag,
  burundi: BurundiFlag,
  brazil: BrazilFlag,
  'british-indian-ocean-territory': BritishIndianOceanTerritoryFlag,
  'brunei-darussalam': BruneiDarussalamFlag,
  'cabo-verde': CaboVerdeFlag,
  cambodia: CambodiaFlag,
  cameroon: CameroonFlag,
  'united-arab-emirates': UAEFlag,
  'united-states': USAFlag,
  canada: CanadaFlag,
  'cayman-islands': CaymanIslandsFlag,
  'central-african-republic': CentralAfricanRepublicFlag,
  chad: ChadFlag,
  china: ChinaFlag,
  chile: ChileFlag,
  'christmas-island': ChristmasIslandFlag,
  'cocos-islands': CocosIslandsFlag,
  colombia: ColombiaFlag,
  comors: ComorsFlag,
  'cook-islands': CookIslandsFlag,
  'costa-rica': CostaRicaFlag,
  croatia: CroatiaFlag,
  cuba: CubaFlag,
  curacao: CuracaoFlag,
  cyprus: CyprusFlag,
  'czech-republic': CzechRepublicFlag,
  'democratic-republic-of-the-congo': DemocraticRepublicOfTheCongoFlag,
  denmark: DenmarkFlag,
  djibouti: DjiboutiFlag,
  dominica: DominicaFlag,
  'dominican-republic': DominicanRepublicFlag,
  ecuador: EcuadorFlag,
  egypt: EgyptFlag,
  'el-salvador': ElSalvadorFlag,
  england: EnglandFlag,
  'equatorial-guinea': EquatorialGuineaFlag,
  eritrea: EritreaFlag,
  estonia: EstoniaFlag,
  ethiopia: EthiopiaFlag,
  'european-union': EuropeanUnionFlag,
  france: FranceFlag,
  'ivory-coast': IvoryCoastFlag,
  israel: IsraelFlag,
  italy: ItalyFlag,
  spain: SpainFlag,
  'united-kingdom': UKFlag,
  russia: RussiaFlag,
  jamaica: JamaicaFlag,
  japan: JapanFlag,
  jersey: JerseyFlag,
  jordan: JordanFlag,
  fiji: FijiFlag,
  finland: FinlandFlag,
  'french-guiana': FrenchGuianaFlag,
  'french-polynesia': FrenchPolynesiaFlag,
  'french-southern-and-antarctic-lands': FrenchSouthernAndAntarcticLandsFlag,
  kuwait: KuwaitFlag,
  kyrgyzstan: KyrgyzstanFlag,
  kazakhstan: KazakhstanFlag,
  kenia: KeniaFlag,
  kiribati: KiribatiFlag,
  georgia: GeorgiaFlag,
  guadeloupe: GuadeloupeFlag,
  guam: GuamFlag,
  gibraltar: GibraltarFlag,
  greece: GreeceFlag,
  haiti: HaitiFlag,
  'heard-and-mcdonald-islands': HeardAndMcDonaldIslandsFlag,
  honduras: HondurasFlag,
  'hong-kong': HongKongFlag,
  hungary: HungaryFlag,
  iceland: IcelandFlag,
  india: IndiaFlag,
  indonesia: IndonesiaFlag,
  iran: IranFlag,
  iraq: IraqFlag,
  ireland: IrelandFlag,
  'isle-of-man': IsleOfManFlag,
  'guinea-bissau': GuineaBissauFlag,
  'falkland-islands': FalklandIslandsFlag,
  'faroe-islands': FaroeIslandsFlag,
  'federated-states-of-micronesia': FederatedStatesOfMicronesiaFlag,
  guatemala: GuatemalaFlag,
  guernsey: GuernseyFlag,
  guinea: GuineaFlag,
  gabon: GabonFlag,
  gambia: GambiaFlag,
  guyana: GuyanaFlag,
  grenada: GrenadaFlag,
  germany: GermanyFlag,
  'south-georgia-and-the-south-sandwich-islands': SGSSIFlag,
  saba: SabaFlag,
  'saint-barthélemy': SaintBarthélemyFlag,
  'saint-helena': SaintHelenaFlag,
  'saint-kitts-and-nevis': SaintKittsAndNevisFlag,
  'saint-lucia': SaintLuciaFlag,
  'saint-pierre-and-miquelon': SaintPierreAndMiquelonFlag,
  'saint-vincent-and-the-grenadines': SaintVincentAndTheGrenadinesFlag,
  samoa: SamoaFlag,
  'san-marino': SanMarinoFlag,
  'sao-tome-and-principe': SaoTomeAndPrincipeFlag,
  'saudi-arabia': SaudiArabiaFlag,
  senegal: SenegalFlag,
  serbia: SerbiaFlag,
  seychelles: SeychellesFlag,
  'sierra-leone': SierraLeoneFlag,
  singapore: SingaporeFlag,
  'sint-eustatius': SintEustatiusFlag,
  'sint-maarten': SintMaartenFlag,
  slovakia: SlovakiaFlag,
  slovenia: SloveniaFlag,
  'solomon-islands': SolomonIslandsFlag,
  somalia: SomaliaFlag,
  'south-africa': SouthAfricaFlag,
  'south-sudan': SouthSudanFlag,
  'sri-lanka': SriLankaFlag,
  sudan: SudanFlag,
  suriname: SurinameFlag,
  swaziland: SwazilandFlag,
  sweden: SwedenFlag,
  switzerland: SwitzerlandFlag,
  syria: SyriaFlag,
  taiwan: TaiwanFlag,
  tajikistan: TajikistanFlag,
  tanzania: TanzaniaFlag,
  thailand: ThailandFlag,
  'timor-leste': TimorLesteFlag,
  togo: TogoFlag,
  tokelau: TokelauFlag,
  tonga: TongaFlag,
  'trinidad-and-tobago': TrinidadAndTobagoFlag,
  tunisia: TunisiaFlag,
  turkey: TurkeyFlag,
  turkmenistan: TurkmenistanFlag,
  'turks-and-caicos-islands': TurksAndCaicosIslandsFlag,
  tuvalu: TuvaluFlag,
  uganda: UgandaFlag,
  ukraine: UkraineFlag,
  uruguay: UruguayFlag,
  uzbekistan: UzbekistanFlag,
  vanuatu: VanuatuFlag,
  'vatican-city-state': VaticanCityStateFlag,
  venezuela: VenezuelaFlag,
  vietnam: VietnamFlag,
  'virgin-islands-british': VirginIslandsBritishFlag,
  'virgin-islands-usa': VirginIslandsUSFlag,
  wales: WalesFlag,
  'wallis-and-futuna': WallisAndFutunaFlag,
  'western-sahara': WesternSaharaFlag,
  yemen: YemenFlag,
  zambia: ZambiaFlag,
  zimbabwe: ZimbabweFlag,
  ghana: GhanaFlag,
  laos: LaosFlag,
  latvia: LatviaFlag,
  lebanon: LebanonFlag,
  lesotho: LesothoFlag,
  liberia: LiberiaFlag,
  libya: LibyaFlag,
  liechtenstein: LiechtensteinFlag,
  lithuania: LithuaniaFlag,
  luxembourg: LuxembourgFlag,
  macao: MacaoFlag,
  madagascar: MadagascarFlag,
  malawi: MalawiFlag,
  malaysia: MalaysiaFlag,
  maldives: MaldivesFlag,
  mali: MaliFlag,
  malta: MaltaFlag,
  'marshall-islands': MarshallIslandsFlag,
  martinique: MartiniqueFlag,
  mauritania: MauritaniaFlag,
  mauritius: MauritiusFlag,
  mayotte: MayotteFlag,
  mexico: MexicoFlag,
  moldova: MoldovaFlag,
  monaco: MonacoFlag,
  mongolia: MongoliaFlag,
  montenegro: MontenegroFlag,
  montserrat: MontserratFlag,
  morocco: MoroccoFlag,
  mozambique: MozambiqueFlag,
  myanmar: MyanmarFlag,
  namibia: NamibiaFlag,
  nauru: NauruFlag,
  nepal: NepalFlag,
  netherlands: NetherlandsFlag,
  'new-caledonia': NewCaledoniaFlag,
  'new-zealand': NewZealandFlag,
  nicaragua: NicaraguaFlag,
  niger: NigerFlag,
  nigeria: NigeriaFlag,
  niue: NiueFlag,
  'norfolk-island': NorfolkIslandFlag,
  'north-macedonia': NorthMacedoniaFlag,
  'north-korea': NorthKoreaFlag,
  'northern-ireland': NorthernIrelandFlag,
  'northern-mariana-islands': NorthernMarianaIslandsFlag,
  norway: NorwayFlag,
  oman: OmanFlag,
  pakistan: PakistanFlag,
  palau: PalauFlag,
  panama: PanamaFlag,
  'papua-new-guinea': PapuaNewGuineaFlag,
  paraguay: ParaguayFlag,
  peru: PeruFlag,
  philippines: PhilippinesFlag,
  'pitcairn-islands': PitcairnIslandsFlag,
  poland: PolandFlag,
  portugal: PortugalFlag,
  'puerto-rico': PuertoRicoFlag,
  qatar: QatarFlag,
  'republic-of-the-congo': RepublicOfTheCongoFlag,
  reunion: ReunionFlag,
  romania: RomaniaFlag,
  'russian-federation': RussianFederationFlag,
  rwanda: RwandaFlag,
  scotland: ScotlandFlag,
  'saint-martin': SaintMartinFlag,
  'south-korea': SouthKoreaFlag
};
export var flags = flagsMap;
//# sourceMappingURL=flags.types.js.map